import "./Sedation.module.css";
import Header from "../../reusable_sections/Header";
import Footer from "../../reusable_sections/Footer";
import FestivalOverview from "./sections/FestivalOverview";
import KeyBenefits from "./sections/KeyBenefits";
import QuickContactCta from "./sections/QuickContactCta";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
export default function SedationPage() {
  return <div>
      <Header />
      <FestivalOverview />
      <KeyBenefits />
      <QuickContactCta />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}